export default "__VITE_ASSET__CF$SsFdO__"